import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

// Get all projects
const getProjects = async () => {
  const response = await axios.get(`${base_url}project/`);
  return response.data;
};

// Create project
const createProject = async (project) => {
  console.log("Data being sent to backend:", project);

  const response = await axios.post(
    `${base_url}project/`,
    project,
    config
  );

  return response.data;
};

// Get single project by slug
const getProject = async (slug) => {
  try {
    const response = await axios.get(
      `${base_url}project/${slug}`,
      config
    );
    return response.data;
  } catch (error) {
    console.error("Error while fetching project:", error);
    throw error;
  }
};

// Update project
const updateProject = async (project) => {
  console.log("Data being sent to backend:", project.projectData);

  const response = await axios.put(
    `${base_url}project/${project.slug}`,
    project.projectData,
    config
  );

  return response.data;
};

// Delete project
const deleteProject = async (slug) => {
  const response = await axios.delete(
    `${base_url}project/${slug}`,
    config
  );

  return response.data;
};

const projectService = {
  getProjects,
  createProject,
  getProject,
  updateProject,
  deleteProject,
};

export default projectService;
